/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import { AnyAction } from 'redux';
import {
    OVERLAY_SET_GHOST_MODE,
    SET_OVERLAY_HIGHLIGHT_HORIZONTAL_LIMIT,
    SET_OVERLAY_HIGHLIGHT_HORIZONTAL_POSITION,
    SET_OVERLAY_HIGHLIGHT_VERTICAL_LIMIT,
    SET_OVERLAY_HIGHLIGHT_VERTICAL_POSITION,
} from './overlayhighlight.types';
import { overlaySetGhostModeAction } from './overlayhighlight.actions';

const initialState: {
    isOverlayGhostHighlightActive: boolean;
    verticalPosition: number;
    horizontalPosition: number;
    verticalLimit: number;
    horizontalLimit: number;
} = {
    isOverlayGhostHighlightActive: false,
    verticalPosition: 0,
    horizontalPosition: 0,
    verticalLimit: 0,
    horizontalLimit: 0,
};

const overlayHighlightReducer = (state = initialState, { type, payload } = <AnyAction>{}) => {
    switch (type) {
        case SET_OVERLAY_HIGHLIGHT_VERTICAL_POSITION:
            return {
                ...state,
                verticalPosition: payload.verticalPosition,
            };
        case SET_OVERLAY_HIGHLIGHT_HORIZONTAL_POSITION:
            return {
                ...state,
                horizontalPosition: payload.horizontalPosition,
            };
        case SET_OVERLAY_HIGHLIGHT_VERTICAL_LIMIT:
            return {
                ...state,
                verticalLimit: payload.verticalLimit,
            };
        case SET_OVERLAY_HIGHLIGHT_HORIZONTAL_LIMIT:
            return {
                ...state,
                horizontalLimit: payload.horizontalLimit,
            };
        case OVERLAY_SET_GHOST_MODE:
            return {
                ...state,
                isOverlayGhostHighlightActive: payload.isOverlayGhostHighlightActive,
            };
        default:
            return state;
    }
};

export const overlayEnableGhostMode = () => (dispatch: Function) => {
    dispatch(overlaySetGhostModeAction(true));
};
export const overlayDisableGhostMode = () => (dispatch: Function) => {
    dispatch(overlaySetGhostModeAction(false));
};

export default overlayHighlightReducer;
